import {ChevronRightIcon, HomeIcon} from "@heroicons/react/20/solid";
import classNames from "classnames";
import Link from "next/link";
import {addSlashIfNotAbsoluteUrl} from "../../utils/Helpers";

export default function Breadrcumbs(props: { pages: any[] }) {
    return <></>
    // return <nav className="flex" aria-label="Breadcrumb">
    //     <ol role="list" className="flex items-center space-x-4">
    //         <li className={'list-none'}>
    //             <div className={'flex items-center'}>
    //                 <Link href="/" className="text-gray-400 hover:text-gray-500">
    //                     <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true"/>
    //                     <span className="sr-only">Home</span>
    //                 </Link>
    //             </div>
    //         </li>
    //         {props.pages.map((page) => (
    //             <li key={page.name} className={'list-none'}>
    //                 <div className="flex items-center">
    //                     <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true"/>
    //                     <Link
    //                         href={addSlashIfNotAbsoluteUrl(page.href)}
    //                         className={
    //                             classNames({
    //                                 "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700": true,
    //                                 "text-secondary": page.current,
    //                             })
    //                         }
    //                         aria-current={page.current ? 'page' : undefined}
    //                     >
    //                         {page.name}
    //                     </Link>
    //                 </div>
    //             </li>
    //         ))}
    //     </ol>
    // </nav>
}